import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AirplaneModeInterceptor } from './airplane-mode/airplane-mode.interceptor';
import { ApiInterceptor } from './api/api.interceptor';

// The order of these interceptors is intentional, change at your own risk
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AirplaneModeInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
];
